export * from './badges.component';